"use strict";
//@ts-nocheck
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * mehrwert jQuery attachThrobber chain plugin for GS1
 *
 * @author		Michael Straschek <typo3@mehrwert.de>
 * @package		tx_gs1base
 * @license		GPL
 */
const spin_js_1 = require("spin.js");
(function ($) {
    /**
     * Attach throbber function
     *
     * @param options
     * @return {*}
     */
    $.fn.attachThrobber = function (options) {
        /**
         * Iterate an return
         */
        return this.each(function (i, item) {
            /**
             * This css class may be user for styling purposes
             * (e.g. hide original icon when in button)
             * and is not mandatory to this script
             */
            $(item).addClass('has-throbber');
            var opts = {
                lines: 17 // The number of lines to draw
                ,
                length: 20 // The length of each line
                ,
                width: 2 // The line thickness
                ,
                radius: 20 // The radius of the inner circle
                ,
                scale: 1 // Scales overall size of the spinner
                ,
                corners: 1 // Corner roundness (0..1)
                ,
                color: '#fe3e14' // #rgb or #rrggbb or array of colors
                ,
                opacity: 0.1 // Opacity of the lines
                ,
                rotate: 16 // The rotation offset
                ,
                direction: 1 // 1: clockwise, -1: counterclockwise
                ,
                speed: 1.6 // Rounds per second
                ,
                trail: 48 // Afterglow percentage
                ,
                fps: 20 // Frames per second when using setTimeout() as a fallback for CSS
                ,
                zIndex: 2e9 // The z-index (defaults to 2000000000)
                ,
                className: 'spinner' // The CSS class to assign to the spinner
                ,
                top: '50%' // Top position relative to parent
                ,
                left: '50%' // Left position relative to parent
                ,
                shadow: false // Whether to render a shadow
                ,
                hwaccel: false // Whether to use hardware acceleration
                ,
                position: 'absolute' // Element positioning
            };
            var spinner = new spin_js_1.Spinner(opts).spin(item);
        });
    };
    /**
     * Detach/hide throbber function
     *
     * @return {*}
     */
    $.fn.detachThrobber = function () {
        /**
         * Iterate an return
         */
        return this.each(function (i, item) {
            /**
             * This css class may be for styling purposes
             * and is not mandatory to this script
             */
            $(item).removeClass('has-throbber');
            $(item).fadeTo(250, 1);
            // IE FIX
            $('.throbber').remove();
        });
    };
})(jQuery);
